export enum AdminCaracterisiquePanelContextEnum {
  societe = 'societe',
  template = 'template',
  patrimoine = 'patrimoine'
}
